import { CardMedia, Grid, makeStyles, Typography, Card, CardContent, Box } from '@material-ui/core';
import { Button, useAuthenticator } from '@aws-amplify/ui-react';
import { connect } from 'react-redux';
import { Branding } from '../../branding';
import { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import awsconfig from '../../aws-exports';
import { QRCodeCanvas } from 'qrcode.react';

const useStyles = makeStyles((theme) => ({
  rootContainer: {
    display: 'flex',
    justifyContent: 'center', // Center horizontally
    alignItems: 'center', // Center vertically
    minHeight: '100vh', // Full viewport height
  },
  card: {
    minWidth: '55em',
    maxWidth: '27em',
    minHeight: '50em',
  },
  cardMedia: {
    width: 200,
    height: 90,
    backgroundSize: 'contain',
  },
  messageHeading: {
    fontSize: '24px',
    fontWeight: '700',
    fontFamily: 'Roboto, sans-serif',
    color: Branding.primary,
    margin: '8px 0px 8px 0px',
  },
  messageHeading2: {
    fontSize: '18px',
    fontWeight: '700',
    fontFamily: 'Roboto, sans-serif',
    color: Branding.primary,
    margin: '8px 0px 8px 0px',
  },
  message: {
    fontSize: '16px',
    fontWeight: '400',
    fontFamily: 'Roboto, sans-serif',
    color: 'rgba(0,0,0,0.60)',
    align: 'center',
    padding: '0px 12px 0px 12px',
  },
  spinnerStyle: {
    color: '#0C938F',
    margin: '8px 0px 8px 0px',
  },
  mainGrid: {
    justifyContent: 'space-evenly',
    minHeight: '70vh',
  },
  footerGrid: { marginTop: '10em' },
  grid: {
    paddingLeft: '10%',
    paddingTop: '4em',
    paddingBottom: '4em',
  },
  button: {
    width: '25%',
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    marginRight: theme.spacing(2),
    borderRadius: '20px',
    fontSize: '14px',
    fontWeight: '700',
  },
  qrCode: {
    width: '100%',
    maxWidth: '200px',
    margin: '20px 0',
  },
  error: {
    color: 'red',
  },
}));

const mapStateToProps = (state) => {
  return {
    user: state.app.user,
    lang: state.app.lang,
    tos: state.app.tos,
  };
};

const MFAAuthenticatorSetup = ({ onClose, onSubmit }) => {
  const classes = useStyles();
  const { user } = useAuthenticator((context) => [context.user]);
  const [qrCode, setQrCode] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const setupTOTPs = async () => {
      try {
        const secretCode = await Auth.setupTOTP(user);
        const stage = awsconfig.deploymentStage
          ? `${awsconfig.deploymentStage !== 'prod' ? `${awsconfig.deploymentStage}-` : ''}${user.attributes.email}`
          : '';
        const cleanSecret = secretCode.replace(/=/g, '').toUpperCase();
        const str = `otpauth://totp/${encodeURIComponent(`Brightpath:${stage}`)}?secret=${cleanSecret}&issuer=${encodeURIComponent('Brightpath')}&algorithm=SHA1&digits=6&period=30`;
        setQrCode(str);
      } catch (e) {
        setError(e.message);
        console.error('Error setting up TOTP:', e);
      }
    };
    setupTOTPs();
  }, [user, setError]);

  const qrOptions = {
    errorCorrectionLevel: 'H',
    margin: 2,
    width: 200,
    color: {
      dark: '#000',
      light: '#fff'
    }
  };

  return (
    <div className={classes.rootContainer}>
      <Grid container spacing={2} className={classes.mainGrid}>
        <Card variant="outlined" className={classes.card}>
          <CardContent className={classes.cardContent}>
            <Grid className={classes.grid} container item xs={12} spacing={3}>
              <CardMedia
                className={classes.cardMedia}
                image={
                  'https://s3.amazonaws.com/pe-newco-media/wp-content/uploads/2022/07/19122350/YouScience_1320x393_transparent.png'
                }
                title={Branding.appName}
              />
            </Grid>
            <Grid container className={classes.grid} style={{ paddingTop: '0' }}>
              <Grid item style={{ paddingLeft: '0%' }}>
                <Typography className={classes.messageHeading} align="center">
                  Configure Authenticator App
                </Typography>
              </Grid>

              <Grid item xs={12} style={{ paddingTop: '2em' }}>
                <Typography className={classes.message}>1. Install the Authenticator App on your phone</Typography>

                <Typography className={classes.message} style={{ marginTop: '1em' }}>
                  2. In the app click the plus icon and choose "Scan QR code"
                </Typography>

                <Typography className={classes.message} style={{ marginTop: '1em' }}>
                  3. Scan the image below
                </Typography>
              </Grid>
            </Grid>
            <Grid container className={classes.grid} style={{ paddingTop: '0em' }}>
              <Box component="div" style={{ width: '100%', paddingLeft: '2em' }}>
                {qrCode && <QRCodeCanvas value={qrCode} {...qrOptions} />}
              </Box>
              {error && (
                <Typography className={classes.error}>
                  {typeof error === 'string' ? error : JSON.stringify(error)}
                </Typography>
              )}
            </Grid>

            <Grid container className={classes.grid} style={{ paddingTop: '0em', paddingRight: '4em' }}>
              <Box component="div" align="right" style={{ width: '100%' }}>
                <Button variant="outlined" className={classes.button} onClick={onClose} variation="secondary">
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  className={classes.button}
                  style={{ marginLeft: '1em' }}
                  onClick={() => onSubmit()}
                  variation="primary"
                >
                  Next
                </Button>
              </Box>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
};

export default connect(mapStateToProps)(MFAAuthenticatorSetup);
